"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SolanaSignInMethod = exports.SolanaSignMessageMethod = exports.SolanaSignAndSendTransactionMethod = exports.SolanaSignTransactionMethod = exports.StandardEventsMethod = exports.StandardDisconnectMethod = exports.StandardConnectMethod = void 0;
exports.isWalletAdapterCompatibleStandardWallet = isWalletAdapterCompatibleStandardWallet;
exports.toUiWalletAccount = toUiWalletAccount;
exports.toUiWallet = toUiWallet;
// Constants for standard method names
exports.StandardConnectMethod = 'standard:connect';
exports.StandardDisconnectMethod = 'standard:disconnect';
exports.StandardEventsMethod = 'standard:events';
exports.SolanaSignTransactionMethod = 'solana:signTransaction';
exports.SolanaSignAndSendTransactionMethod = 'solana:signAndSendTransaction';
exports.SolanaSignMessageMethod = 'solana:signMessage';
exports.SolanaSignInMethod = 'solana:signIn';
/**
 * Check if a wallet is compatible with the wallet adapter
 */
function isWalletAdapterCompatibleStandardWallet(wallet) {
    return (exports.StandardConnectMethod in wallet.features &&
        exports.StandardEventsMethod in wallet.features &&
        (exports.SolanaSignAndSendTransactionMethod in wallet.features || exports.SolanaSignTransactionMethod in wallet.features));
}
/**
 * Convert a standard account to a UI account
 */
function toUiWalletAccount(account) {
    // Convert chains and features to IdentifierArray format
    var chains = (account.chains || ['solana:mainnet-beta']);
    var features = (account.features || ['solana:publicKey']);
    return {
        address: account.address,
        publicKey: account.publicKey,
        chains: chains,
        features: features,
        label: account.label,
        icon: undefined
    };
}
/**
 * Convert a wallet to a UI wallet representation
 */
function toUiWallet(wallet) {
    // Convert WalletAccount to StandardWalletAccount for mapping
    var accounts = wallet.accounts.map(function (acc) {
        var standardAccount = {
            address: acc.address,
            publicKey: new Uint8Array(acc.publicKey),
            features: Array.from(acc.features || []),
            chains: Array.from(acc.chains || []),
            label: acc.label
        };
        return standardAccount;
    });
    return {
        name: wallet.name,
        icon: wallet.icon,
        chains: Array.from(wallet.chains),
        features: Object.keys(wallet.features),
        accounts: accounts.map(toUiWalletAccount),
        version: wallet.version,
        website: wallet.website
    };
}
